<template>
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
  >
    <path d="M0.246643 2V8C0.246643 9.10457 1.14207 10 2.24664 10H10.2466C11.3512 10 12.2466 9.10457 12.2466 8V3C12.2466 1.89543 11.3512 1 10.2466 1H5.42203L4.30899 0.109566C4.22033 0.0386404 4.11018 0 3.99664 0H2.24664C1.14207 0 0.246643 0.895431 0.246643 2ZM1.24664 2C1.24664 1.44772 1.69436 1 2.24664 1H3.82125L4.68938 1.6945L3.80334 2.49998H1.24664V2ZM5.83994 2H10.2466C10.7989 2 11.2466 2.44772 11.2466 3V8C11.2466 8.55228 10.7989 9 10.2466 9H2.24664C1.69436 9 1.24664 8.55229 1.24664 8V3.49998H3.99664C4.12103 3.49998 4.24094 3.45362 4.33298 3.36995L5.83994 2Z" />
  </svg>
</template>
